<template>
  <div class="overview">
    <app-header title="服务详情">
      <div slot="tips" class="overview-tips" @click="goToMessage">
        <i class="iconfont icontixing"></i>
      </div>
    </app-header>

    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <div class="scroll-box">
        <app-card-list :cardList="numArray" style="margin-bottom: 20px">
          <h3 v-for="(item, index) in numArray" :key="index" :slot="index.toString()">
            {{ item.value }}
          </h3>
        </app-card-list>
        <div class="app-card-list">
          <div class="card" @click="$router.push('/charge')">
            <img src="../../assets/jf_cz.png" />
            <p>充值</p>
          </div>
          <div class="card" @click="$router.push('/renew')">
            <img src="../../assets/jf_xf.png" />
            <p>续费</p>
          </div>
          <div class="card" @click="$router.push('/open-list')">
            <img src="../../assets/jf_kt.png" />
            <p>开通</p>
          </div>
          <div class="card" @click="$router.push('/netin')">
            <img src="../../assets/jf_bg.png" />
            <p>入网</p>
          </div>
        </div>
      
        <!-- 申请通过 -->
        <div class="apply-box"  v-show="applyList.length !== 0">
          <div class="apply-title">
            <div class="title-text">申请通过功能</div>
            <div class="title-more" @click="intoMore">更多</div>
          </div>
          <ul class="apply-ul">
            <li v-for="(item, index) in applyList" :key="index">
              <div class="list-title">{{ item.productName }}</div>
              <div class="list-message">{{ item.moduleName }}</div>
              <div class="list-time">{{ item.applyTime }}</div>
              <div class="list-status">申请通过</div>
            </li>
            <Button v-show="applyList.length !== 0" class="apply-btn" @click="confirmApply">确定缴费</Button>
          </ul>
        </div>
        
        <!--我的服务-->
        <div class="service-box">
          <div class="service-header">
            <div class="title-text">我的服务</div>
            <div class="product-select" @click="openProductPop">{{ currentProduct.productName }}<i class="iconfont iconxiala"></i></div>
          </div>
          <my-service :orderList="orderList" v-show="orderList.length !== 0"></my-service>
        </div>
      </div>
    </pull-to>
  </div>
</template>

<script>
import PullTo from 'vue-pull-to';
import AppHeader from 'components/app-header';
import AppCardList from './components/app-card-list';
import MyService from './components/MyService.vue';
import apis from 'api/index';
import { mapMutations, mapGetters } from 'vuex';
import { commonMixin } from 'common/js/mixin';

export default {
  mixins: [commonMixin],
  components: {
    AppHeader,
    AppCardList,
    MyService,
    PullTo,
  },
  data() {
    return {
      // 中间导航的几个图标
      orderList: [],
      orderTotal: 0,
      applyList: [],
      orderPageNumber: 1,
      orderPageSize: 10,
      balance: 0, // 账户余额
      urgentNum: 0, // 急需续费数量
      billNum: 0, // 最近消费账单数量
      productList: [], 
      currentProduct: {}
    }
  },
  computed: {
    groupId() {
      return this.userAllInfo.enterprise.id;
    },
    isLoadAll() {
      return Boolean(this.orderTotal > this.orderPageNumber * this.orderPageSize);
    },
    numArray() {
      return this.caclTablist(this.balance, this.urgentNum, this.billNum);
    },
    ...mapGetters(['userAllInfo', 'selectProduct'])
  },
  created() {
    this.fetchOrderCount().then(res => {
      this.fetchServiceList('reset');
    });
    this.fetchAccount();
    this.fetchApplyList();
  },
  methods: {
    goToMessage() {
      this.$router.push({ name: 'message-list' });
    },
    caclTablist(balance = 0, urgent = 0, bill = 0) {
      return [
         {
          title: '账户余额',
          value: balance,
        },
        {
          title: '急需续费',
          value: urgent,
          route: 'urgent'
        },
        {
          title: '最近消费',
          value: '账单',
          route: 'bill-list',
        }
      ]
    },
    intoMore() {
      this.$router.push({name: 'open-list', query: { status: 2 }});
    },
    // 确定缴费
    confirmApply() {
      this.setPayList(this.applyList);
      this.$router.push({name: 'charge-pay'});
    },
    // 打开选择pop
    openProductPop() {
      if (!this.picker) {
        let selectedIndex = this.productList.findIndex(item => item.value === this.currentProduct.value);
        this.picker = this.$createPicker({
          title: '选择产品',
          data: [this.productList],
          onSelect: this.changeProduct,
          selectedIndex: [selectedIndex]
        })
      }
      this.picker.show();
    },
    changeProduct(value) {
      this.currentProduct = this.productList.filter(item => item.value === value[0])[0];
      this.setSelectProduct(this.currentProduct);
      this.fetchServiceList('reset');
    },
    async fetchOrderCount() {
      try {
        const res = await apis.orderCount({groupId: this.groupId, status: 5});
        this.productList = this._normalizeProduct(res);
        if(JSON.stringify(this.selectProduct) === '{}') {
          this.currentProduct = res[0];
        } else {
          this.currentProduct = this.selectProduct;
        }
        return res;
      } catch(err) {
        console.error(err);
      }
    },
    async fetchAccount() {
      try {
        const res = await apis.getAccount();
        this.balance = res.balance;
        this.urgentNum = res.expireDeptNum + res.expireDeviceNum;
      } catch(err) {
        console.error(err);
      }
    },
    async fetchServiceList(type = 'normal') {
      let params = {};
      params.groupId = this.groupId;
      params.no = this.orderPageNumber;
      params.limit = this.orderPageSize;
      params.status = 5;
      params.productId = this.currentProduct.productId;
      try {
        const res = await apis.ordersModuleOrder(params);
        if(type === 'reset') {
          this.orderList = res.records;
        } else {
          this.orderList = res.records.concat(this.orderList);
        }
        this.orderTotal = res.total;
      } catch(err) {
        console.error(err);
      }
    },
    loadmore(loaded) {
      if(this.orderTotal <= this.orderPageNumber * this.orderPageSize) {
        return false;
      }
      this.orderPageNumber +=1;
      this.fetchServiceList().then(res => {
        loaded('done');
      });
    },
    async fetchApplyList() {
      try {
        let params = {};
        params.groupId = this.userAllInfo.enterprise.id;
        params.no = 1;
        params.limit = 3;
        params.status = 2;
        const res = await apis.ordersModuleOrder(params);
        this.applyList = res.records;
      } catch(err) {
        console.error(err);
      }
    },
    _normalizeProduct(data) {
      data.forEach(item => {
        item.text = item.productName;
        item.value = item.productId;
      });
      return data;
    },
    ...mapMutations(['setPayList', 'setSelectProduct'])
  }
}
</script>


<style src="./index.scss" lang="scss" scoped></style>
